// extracted by mini-css-extract-plugin
module.exports = {"root":"add-anime-character-page_root__2RYCZ","submission":"add-anime-character-page_submission__1KRyU","button":"add-anime-character-page_button__2THqu"};